import { Pipe, PipeTransform } from '@angular/core';
import { CurrencyPipe } from '@angular/common';

@Pipe({ name: 'customStrikeRate' })
export class CustomCurrency2 implements PipeTransform {
    constructor(private currencyPipe: CurrencyPipe) {}

    transform(value: any, currencyCode?: string, locale?: any): string {
        if (value != undefined) {
            let output = this.currencyPipe.transform(value, currencyCode, 'symbol', '1.1-1', locale);
            return output.replace('€', '');
        } else {
            return 'NA';
        }
    }
}
